export enum LevelAccordions {
	PROMOTIONS = "promotions",
	SUMMARY = "summary",
	LEADERBOARD = "leaderboard",
}
